<template>
    <div class="pay">
        <!-- <img :src="details" alt="">
        <span>{{minute}}分钟 {{seconds}}秒后自动关闭</span> -->
        <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16"><div class="left"></div></el-col>
        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8"><div class="right"></div></el-col>
    </div>
</template>
<script>
import request from "@/utils/request";
export default {
    data(){
        return{
            details:'',
            timer:null,
            time:null,
            count:0,
            minutes: 4,   // 此处修改分钟数量
            seconds: 59,     // 此处修改秒数数量
            loading:true
        }
    },
    created(){
        // this.setPay()
    },
    watch: {
      second: {
        handler (newVal) {
          this.num(newVal)
        }
      },
      minute: {
        handler (newVal) {
          newVal
        }
      }
    },
    computed: {
      second: function () {
        return this.num(this.seconds)
      },
      minute: function () {
        return this.minutes
      }
    },
    methods:{
        num: function (n) {
            return n < 10 ? '0' + n : '' + n
        },
        add: function () {
            var _this = this
            var time = window.setInterval(function () {
                if (_this.seconds === 0 && _this.minutes !== 0) {
                    _this.seconds = 59
                    _this.minutes -= 1
                } else if (_this.minutes === 0 && _this.seconds === 0) {
                    _this.seconds = 0
                    window.clearInterval(time)
                } else {
                    _this.seconds -= 1
                }
            }, 1000)
        },
        setPay() {
            this.loading=true
            request({
                url: "/api/userend/pay",
                method: "post",
                params: {order_no:this.$route.query.order_no,pay_type:2}
            }).then(response => {
                this.details=response.data
                this.add()
                this.loading=false
                this.timer=setInterval(() => {
                    this.isPay()
                }, 1000);
            });
        },
        isPay() {
            request({
                url: "/api/userend/orderStatus",
                method: "get",
                params: {order_no:this.$route.query.order_no}
            }).then(response => {
                if(this.minutes==0 && this.seconds){
                    clearInterval(this.timer)
                    window.opener.location.reload();window.opener.focus();window.close();
                }
                else if(response.data.pay_status!=1){
                    clearInterval(this.timer)
                    window.opener.location.reload();window.opener.focus();window.close();
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
    .pay{
        .left{
            height: 500px;
            background: #e4e70b
        }
        .right{
            height: 500px;
            background: #e79a0b
        }
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
        // align-items: center;
        // padding-top: 200px;
        // span{
        //     font-size: 22px;
        //     font-family: PingFangSC-Medium, PingFang SC;
        //     font-weight: 500;
        //     color: #1E2134;
        // }
    }
</style>